import { render, staticRenderFns } from "./VerifikasiSukses.vue?vue&type=template&id=58e50fd2&"
import script from "./VerifikasiSukses.vue?vue&type=script&lang=js&"
export * from "./VerifikasiSukses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports